// Copyright (c) Docugami, Inc. All rights reserved.

import ReactGA from 'react-ga4';
import { Logger, LoggerCategory } from "utils/Logger";
import { TelemetryEvent, TelemetryPageView } from './TelemetryEvents';
import { ITelemetryProvider, TelemetryEventData, TelemetryInitializer } from "./TelemetryProvider";

export class GoogleAnalyticsTelemetryProvider implements ITelemetryProvider {

    get providerId(): string { return "googleAnalytics" }

    constructor(trackingId: string) {

        // don't send a default page view on load, we are doing our own page view tracking
        const options = {
            gaOptions: {
                send_page_view: false
            },
            gtagOptions: {
                send_page_view: false
            }
        };

        ReactGA.initialize(trackingId, options);
        Logger.LogInformation(LoggerCategory.Telemetry, `Google Analytics provider initialized.`);
    }

    trackNamedEvent(name: TelemetryEvent | string, data?: TelemetryEventData): void {
        ReactGA.event({ category: 'User', action: name });
    }

    trackPageView(name: TelemetryPageView | string, data?: TelemetryEventData): void {
        ReactGA.send({ hitType: 'pageview', page: `/${name}`, title: `WebAppPageView_${name}` });
    }

    trackException(error: Error, data?: TelemetryEventData): void {
        // Intentionally left blank, we are not sending exceptions to GA.
    }

    setUserContext(userId: string, accountId: string): void {
        // Intentionally left blank, we are not sending user details to GA.
    }

    clearUserContext(): void {
        // Intentionally left blank, we are not sending the user details to GA.
    }

    addInitializer(initializer: TelemetryInitializer): void {
        // Intentionally left blank, for now we are not sending any additional data to GA.
    }
}
